var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"auth-button",on:{"click":function($event){return _vm.modalsSetShow('Login')}}},[_c('div',{staticClass:"button-inner"},[_c('IconRoblox'),_vm._v(" SIGN IN ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }